import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

// components
import Layout from "./Layout";
import StudentLayout from "./StudentLayout";
import StudentLogin from "../pages/login/StudentLogin";
//react toast

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

// pages
import Error from "../pages/error";
import Login from "../pages/login";
import ad from "../pages/testimonial/Testimonial";

// context
// import { useUserState } from "../context/UserContext";

//firebase
import { AuthContextProvider } from "../context/AuthContext";

import { isMobile, MobileView } from "react-device-detect";

export default function App() {
  // var { isAuthenticated } = useUserState();

  var width = window.innerWidth;
  const useStyles = makeStyles((theme) => ({
    heroContent: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(8, 0, 6),
      marginTop: theme.spacing(10),
    },
  }));
  const classes = useStyles();
  if (isMobile) {
    // document.getElementById("playstore").click();
    window.onload = function () {
      document.getElementById("playstore").click();
    };
    return (
      <MobileView>
        <React.Fragment>
          <div className={classes.heroContent}>
            <Container maxWidth="sm">
              <Typography
                component="h1"
                variant="h2"
                align="center"
                color="textPrimary"
                gutterBottom
              >
                Please Access this website from a PC/Laptop Device.
                <hr />
                To open on Mobile Devices get the ABPhysics app from Playstore.
              </Typography>
              <Typography
                component="h1"
                variant="h2"
                align="center"
                color="textPrimary"
                gutterBottom
              >
                Link to{" "}
                <a
                  id="playstore"
                  href="https://play.google.com/store/apps/details?id=com.abphysics.abphysics&hl=en_IN&gl=US"
                  target="_blank"
                  rel="noreferrer"
                >
                  APP
                </a>
              </Typography>
            </Container>
          </div>
        </React.Fragment>
      </MobileView>
    );
  } else {
    return (
      <AuthContextProvider>
        <HashRouter>
          <Switch>
            {/* <Route
            exact
            path="/adminlogin"
            render={() => <Redirect to="/adlogin" />}
          /> */}
            <Route
              exact
              path="/student"
              render={() => <Redirect to="/student/studentdashboard" />}
            />
            <Route exact path="/" render={() => <Redirect to="/login" />} />
            <Route
              exact
              path="/admin"
              render={() => <Redirect to="/admin/dashboard" />}
            />
            <Route path="/adminlogin" component={Login} />
            <Route path="/student" component={StudentLayout} />
            <Route path="/login" component={StudentLogin} />
            <Route path="/admin" component={Layout} />
            <Route path="/testimonials" component={ad} />
            <Route component={Error} />
          </Switch>
        </HashRouter>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </AuthContextProvider>
    );
  }
}
